// @flow
import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";

import type { DictionaryType } from "../../../global/types/GeneralTypes";
import type { EyeType } from "../../types/faceType";
import type { ImageSearchInputModel } from "../../types/InputModels";
import ErrorDisplay, {
  setErrorMsg
} from "../../../global/components/ErrorDisplay";
import { SubmitButton, SingleCheckBox } from "imagus-components";

type SearchFormStatesType = {
  errors: DictionaryType,
  unique: boolean,
  search_any: boolean,
  includetag: Array<string>,
  excludetag: Array<string>,
  loading: boolean,
  imagen_search: boolean
};

type SearchFormPropsType = {
  faceSearch: { [key: string]: * },
  tagList: string[],
  isV1Model: boolean,
  getTags: Function,
  setSearchedPerson: Function,
  searchByImage: Function,
  setImageError: Function,
  setStep: Function,
  eyes: Array<EyeType> | null,
  selected: number | null,
  ChipInput: React$ComponentType<*>
};

class SearchForm extends Component<SearchFormPropsType, SearchFormStatesType> {
  constructor(props: SearchFormPropsType) {
    super(props);
    this.state = {
      errors: {},
      unique: false,
      search_any: true,
      includetag: [],
      excludetag: [],
      loading: false,
      imagen_search: false
    };
  }

  componentDidMount() {
    this.props.getTags();
  }

  syncChange = (name: string, value: Array<*>): Function => {
    this.setState(
      (): * => ({
        [name]: value
      }),
      this.checkTags
    );
  };

  checkTags = (): * => {
    const { includetag, excludetag } = this.state;
    let check = false;
    for (let i = 0; i < includetag.length; i++) {
      for (let j = 0; j < excludetag.length; j++) {
        if (includetag[i] === excludetag[j]) {
          check = true;
        }
      }
    }
    if (check) {
      this.setState({
        errors: setErrorMsg(
          this.state.errors,
          "tags",
          "Include Tags and Exclude Tags have the same tag."
        )
      });
    } else {
      this.setState({
        errors: setErrorMsg(this.state.errors, "tags", "")
      });
    }
  };

  handleCheckBoxChange = (e: SyntheticInputEvent<*>): * => {
    this.setState({
      [e.target.name]: !this.state[e.target.name]
    });
  };

  handleSubmit = async (e: Event): * => {
    e.preventDefault();
    if (
      this.props.eyes !== null &&
      this.props.selected !== null &&
      this.props.eyes.length > 0
    ) {
      let serializedForm: {} | ImageSearchInputModel = {};
      if (this.state.imagen_search) {
        serializedForm.includetag = this.state.includetag;
        serializedForm.excludetag = this.state.excludetag;
        serializedForm.unique = this.state.unique;
        serializedForm.search_any = this.state.search_any;
        serializedForm.eyes = this.props.eyes[this.props.selected];
        // serializedForm.imagen_search = this.state.imagen_search;
      } else {
        serializedForm = {
          eyes: this.props.eyes[this.props.selected],
          unique: this.state.unique,
          tagAnd: !this.state.search_any,
          includeTags: this.state.includetag,
          excludeTags: this.state.excludetag,
          displayTags: true
        };
      }

      this.props.setSearchedPerson(this.props.eyes[this.props.selected]);
      this.props.searchByImage(
        serializedForm,
        this.props.faceSearch.imgToken,
        this.state.imagen_search
      );
      this.setState({ loading: false });
      this.props.setImageError("");
      this.props.setStep(2);
    } else {
      this.props.setImageError("Please Select a Face.");
    }
  };

  render(): * {
    const errors = this.state.errors;
    let tagList = [];
    if (this.props.tagList) {
      tagList = this.props.tagList.sort().map((tag: string): * => ({
        value: tag,
        label: tag
      }));
    }

    const ChipInput = this.props.ChipInput;

    return (
      <form onSubmit={this.handleSubmit}>
        <Grid container spacing={24}>
          <Grid item xs={12} md={11}>
            <ChipInput
              name="includetag"
              label="Included Tags"
              isMultiple
              placeholder="Tags that the person must have"
              tags={tagList}
              value={this.state.includetag}
              syncChange={this.syncChange}
            />
          </Grid>
          <Grid item xs={12} md={11}>
            <ChipInput
              name="excludetag"
              label="Excluded Tags"
              isMultiple
              placeholder="Tags that the person cannot have"
              tags={tagList}
              value={this.state.excludetag}
              syncChange={this.syncChange}
            />
          </Grid>
          <Grid item xs={6} md={3}>
            <SingleCheckBox
              name="unique"
              value={this.state.unique}
              onChange={this.handleCheckBoxChange}
              label="Unique"
              tooltip={
                this.state.unique
                  ? "Display one enrolment per person"
                  : "Display multiple enrolments per person"
              }
            />
          </Grid>
          <Grid item xs={6} md={3}>
            <SingleCheckBox
              name="search_any"
              value={!this.state.search_any}
              onChange={this.handleCheckBoxChange}
              label="Match All Tags"
              tooltip={
                this.state.search_any
                  ? "A person must only match one of the specified tags"
                  : "A person must match all of the specified tags"
              }
            />
          </Grid>
          {this.props.isV1Model && (
            <Grid item xs={6} md={3}>
              <SingleCheckBox
                name="imagen_search"
                value={this.state.imagen_search}
                onChange={this.handleCheckBoxChange}
                label="V0.9 Model"
                tooltip={
                  this.state.imagen_search ? "Use V0.9 Model" : "Use V1.0 Model"
                }
              />
            </Grid>
          )}
          <Grid item xs={12}>
            <ErrorDisplay errors={errors} />
          </Grid>
          <Grid item xs={12} md={1} />
          <Grid item xs={12} md={9}>
            <SubmitButton
              loading={this.state.loading}
              fullWidth
              disabled={Object.keys(errors).length > 0}
            />
          </Grid>
        </Grid>
      </form>
    );
  }
}

export default SearchForm;
